import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {Permission, PermissionEntity} from "../../../model/permission";

export interface PermissionSelectorProps {

}

export const permissionsSelector = () => createSelector(
  [getUseQueryResultData<Permission[]>],
  (data) => {
    return selectPermissionsAndTransform(
      data ?? [], {}
    );
  }
);

export const permissionsNameSelector = () => createSelector(
  [getUseQueryResultData<Permission[]>],
  (data) => {
    const perms = data ?? []
    return perms.map(p => p.name);
  }
);

export const permissionSelector = () => createSelector(
  [getUseQueryResultData<Permission>],
  (data) => {
    return data ? transformPermission(data) : undefined;
  }
);

export const selectPermissions = (values?: Permission[], selector?: PermissionSelectorProps): Permission[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    return filterIn;
  });
};

export const transformPermission = (value: Permission): PermissionEntity => {
  return PermissionEntity.from(value)
}

export const selectPermissionsAndTransform = (values?: Permission[], selector?: PermissionSelectorProps): PermissionEntity[] => {
  const selected = selectPermissions(values, selector);
  return selected.map(transformPermission);
};
